var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDespair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 76,
    viewBox: "0 0 62 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10400_6844)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 28,
    width: 23,
    height: 19,
    fill: "#CD212E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54 52C54 64.7025 43.7025 75 31 75C18.2975 75 8 64.7025 8 52C8 49.1868 8.50507 46.4915 9.42948 44H12L14.5 40.5L20 43.5L23.5 41L27.5 44.5L33.5 40L41 44L46.5 40L50 44H52.5705C53.4949 46.4915 54 49.1868 54 52Z",
    fill: "#CD212E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0029 68C22.0025 67.9668 22 67.9336 22 67.9004C22 63.0397 26.197 59 31.5 59C36.803 59 41 63.0397 41 67.9004C41 67.9336 40.9975 67.9668 40.9971 68L22.0029 68Z",
    fill: "white",
    stroke: "#CD212E",
    strokeWidth: 2,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 49L22 49.95C22 52.1868 23.567 54 25.5 54C27.433 54 29 52.1868 29 49.95L29 49",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.5 49L33.5 49.95C33.5 52.1868 35.067 54 37 54C38.933 54 40.5 52.1868 40.5 49.95V49",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6445 1C36.2848 1.00003 40.2719 3.78992 42.0156 7.78125C43.4502 6.75096 45.2097 6.14258 47.1113 6.14258C51.9322 6.14269 55.8447 10.0424 55.8447 14.8574C55.8447 15.0713 55.8335 15.2832 55.8184 15.4932C58.8222 16.4486 60.9999 19.2545 61 22.5713C61 26.6763 57.6647 29.9999 53.5557 30C51.9474 30 50.4588 29.4889 49.2412 28.623C47.8821 29.4931 46.2672 30 44.5332 30C42.3138 30 40.2882 29.1722 38.7471 27.8105C36.7243 29.1907 34.2793 30 31.6445 30C28.6831 30 25.962 28.9774 23.8105 27.2705C22.2182 28.9503 19.9657 30 17.4668 30C15.7325 30 14.1171 29.4933 12.7578 28.623C11.5403 29.4886 10.0524 30 8.44434 30C4.33526 29.9999 1 26.6763 1 22.5713C1.00007 18.8022 3.8122 15.6936 7.45312 15.21C7.44846 15.093 7.44434 14.9755 7.44434 14.8574C7.44434 10.0423 11.3568 6.1426 16.1777 6.14258C18.0792 6.14258 19.838 6.75119 21.2725 7.78125C23.0162 3.78974 27.0041 1 31.6445 1Z",
    fill: "#CD212E",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25 35L25 32",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 38L38 35",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28 38L28 34",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35 36L35 33",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10400_6844"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 62,
    height: 76,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDespair);
export default __webpack_public_path__ + "static/media/Despair.8f86c39750ea47189d75c44396ce9108.svg";
export { ForwardRef as ReactComponent };